import { Component, Inject } from '@angular/core';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReferringPhysicianInstituteService } from 'src/app/services/referring-physician-institute.service';
import { ReferringPhysicianInstituteEditInfo } from 'src/app/model/referring-physician/referring-physician-institute';

@Component({
  selector: 'app-referring-physician-institute-dialog',
  templateUrl: 'referring-physician-institute-dialog.component.html',
})
export class ReferringPhysicianInstituteDialogComponent {
  form: FormGroup;
  loading: boolean;
  loadingAction: boolean;
  constructor(public dialogRef: MatDialogRef<ReferringPhysicianInstituteDialogComponent>
    , private notificationToastService: NotificationToastService
    , private referringPhysicianInstituteService: ReferringPhysicianInstituteService
    , private formBuilder: FormBuilder
    , @Inject(MAT_DIALOG_DATA) public data: ReferringPhysicianInstituteEditInfo) {
    this.form = this.formBuilder.group({
      Name: [data? data.Name: null, Validators.required]
    });
  }

    get f() { return this.form.controls; }


  onNoClick(): void {
      this.dialogRef.close(null);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        this.loadingAction = true;
        const id = await this.referringPhysicianInstituteService.update(
          {
            Name: this.form.value.Name,
            Id: this.data? this.data.Id : null
          });

          this.dialogRef.close({
            Id: id,
            Name: this.form.value.Name
          });
      }
    } catch (err) {
      console.error(err);
      this.notificationToastService.error(JSON.stringify(err.error), 'Institución derivante');
    } finally {
      this.loadingAction = false;
    }
  }
}
